import { Icon } from "@iconify/react";

const ModernTextarea = ({
  type,
  variant,
  label,
  placeholder,
  icon,
  disabled,
  containerClassName,
  inputClassName,
  value,
  onChange,
}) => {
  const getVariantClasseNames = () => {
    let containerBaseClassName =
      "flex flex-row items-center overflow-hidden gap-[13px] py-3 lg:px-[25px] px-5 ";
    let inputBaseClassName =
      "flex-1 outline-none border-none bg-transparent line-clamp-1 lg:text-[20px] text-base resize-none h-full w-full ";
    switch (variant) {
      case "white-blur":
        containerBaseClassName += "bg-white-blur-02 rounded-[15px] ";
        inputBaseClassName += "text-white placeholder:text-white ";
        break;
      case "primary-solid":
        containerBaseClassName += "border-[1.5px] border-[#91ADFF] bg-white ";
        inputBaseClassName += "text-[#4E5E6F] placeholder:text-[#4E5E6F] ";
        break;
    }

    containerBaseClassName += ` ${containerClassName ?? ""}`;
    inputBaseClassName += ` ${inputClassName ?? ""}`;
    return { containerBaseClassName, inputBaseClassName };
  };

  const getIconClassNames = () => {
    let baseClassName = "lg:w-7 lg:h-7 w-5 h-5 ";

    switch (variant) {
      case "white-blur":
        baseClassName += "text-white ";
        break;
    }
    return baseClassName;
  };

  return (
    <div className={getVariantClasseNames().containerBaseClassName}>
      {icon && <Icon icon={icon} className={getIconClassNames()} />}
      <textarea
        placeholder={placeholder}
        className={getVariantClasseNames().inputBaseClassName}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default ModernTextarea;
